module.exports = __webpack_public_path__ + "img/egypt.546217bc.jpg";